import { createSlice } from '@reduxjs/toolkit';

// todo: need to remove once api is done
const reducerName = 'usersSettings';
const initialState = {
  searchTerm: null,
  filters: {
    org_role_id: [],
    ats_department_id: [],
    permission: [],
    ats_office_id: [],
    currentTab: 'active',
    isFilterApplied: false,
  },
  page: {
    number: 0,
    offset: 0,
    limit: 20,
  },
  sort: {
    label: 'Created date (Oldest to newest)',
    value: 'asc',
    element: 'created_at',
    order: 'asc',
  },
};

const { reducer, actions: usersSettingsActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    resetJobState: (state, { payload: { key } }) => {
      state[key] = { ...initialState[key] };
    },

    applySort: (state, { payload }) => {
      state.sort = payload;
    },

    applyFilter: (state, { payload }) => {
      const { key, value } = payload;
      state.filters[key] = value;
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = true;
    },

    applyPage: (state, { payload }) => {
      const { page } = payload;
      state.page.number = page;
      state.page.offset = state?.page?.number * state?.page?.limit;
      state.searchTerm = '';
    },

    applyCurrentTab: (state, { payload }) => {
      const { id } = payload;
      if (id) {
        state.filters.currentTab = id;
        state.page = { ...initialState.page };
      }
    },

    clearFilter: (state, { payload }) => {
      const { key } = payload;
      state.filters[key] = initialState.filters[key];
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = Object.values(state.filters).some(
        (filter) => filter !== initialState.filters[key]
      );
    },

    clearAllFilter: (state) => {
      state.filters = { ...initialState.filters };
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = false;
    },

    clearData: (state) => {
      state.sort = { ...initialState.sort };
      state.currentView = initialState.currentView;
      state.searchTerm = '';
    },

    applySearch: (state, { payload }) => {
      state.searchTerm = payload?.searchTerm;
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = payload?.searchTerm?.length > 0;
    },
  },
});

export { usersSettingsActions };
export default reducer;
